import * as angular from "angular";
import {IController} from "angular";
import {SplitService} from "../../../commons/services/split-service.service";

export class ProgramVehiclesByDistanceUnitTableCtrl implements IController {

  // vehicleData: any;
  // isEdit: boolean
  // vehicleOptions: any;
  // excludeOriginIds: any;
  // onVehicleChanged: Function;
  // onChange: Function;
  // onEdit:Function;
  // onDelete: Function;
  //
  // public siteDistanceUnit: any;
  // public currencySymbol: any;
  // public dataReferenceId: string;
  //
  // /* @ngInject */
  // constructor(private splitService) {
  //   this.currencySymbol = splitService.getCurrencySymbol();
  //   this.siteDistanceUnit = this.splitService.getSiteDistanceLargeUnit();
  // }
  //
  // $onChanges(changes) {
  //   if (changes.vehicleData) {
  //     if (this.vehicleData) {
  //       this.dataReferenceId = this.vehicleData.data ? 'data' : 'parentData';
  //     }
  //   }
  // };

  vehicleData: any;
  isExpanded: boolean;
  serviceAreasOptionIds: string[];
  excludeServiceAreasIds: string[];
  onUpdateTier: Function;
  onDeleteTier: Function;

  public dataReferenceId: string;
  public siteDistanceUnit: any;
  public currencySymbol: any;

  constructor(private splitService: SplitService) {
  }

  $onInit() {
    this.currencySymbol = this.splitService.getCurrencySymbol();
    this.siteDistanceUnit = this.splitService.getSiteDistanceLargeUnit();
  }

  $onChanges(changes) {
    if (changes.vehicleData) {
      if (this.vehicleData) {
        this.dataReferenceId = this.vehicleData.data ? 'data' : 'parentData';
      }
    }
  };


}

angular
  .module('bringoz.admin.pricePlan')
  .component('programVehiclesByDistanceUnitTable', {
    require: {
      form: '^form'
    },
    bindings: {
      vehicleData: '<',
      isExpanded: '<?',
      isEdit: '<?',
      onUpdateTier: '&',
      onDeleteTier: '&'
    },
    template: require('./program-vehicles-by-distance-unit-table.html').default,
    controller: ProgramVehiclesByDistanceUnitTableCtrl
  });
